
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import {
//   Box,
//   TextField,
//   MenuItem,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Button,
//   CircularProgress,
//   Tabs,
//   Tab,
// } from "@mui/material";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./MapDeviceToSite.css";
// import apiService from "../../utils/apiservice";


// const API_URL = process.env.REACT_APP_API_DJANGO_URL;

// const MapSiteToCustomer = () => {

//   const [customers, setCustomers] = useState([]);
//   const [selectedCustomer, setSelectedCustomer] = useState("");
//   const [assignedDevices, setAssignedDevices] = useState([]);
//   const [availableDevices, setAvailableDevices] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [tabValue, setTabValue] = useState(0);

//   const token = localStorage.getItem("accessToken");



//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);


//   useEffect(() => {
//     setPage(0);
//   }, [tabValue, selectedCustomer]);

//   const handleChangePage = (event, newPage) => setPage(newPage);
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const getConfig = () => ({
//     headers: {
//       Authorization: `Bearer ${token}`,
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//     data: {},
//   });



//   const fetchSites = async (customerId) => {
//     try {
//       setLoading(true);

//       const res = await apiService({
//         url: `/api/get_sites_for_assignment/`,
//         method: "GET",
//         params: { customer_id: customerId },
//       });

//       const assigned = (res.data.assigned_sites || []).map((d) => ({
//         id: d.asset_id,
//         name: d.name,
//         isAssigned: true,
//       }));

//       const available = (res.data.unassigned_sites || []).map((d) => ({
//         id: d.asset_id,
//         name: d.name,
//         isAssigned: false,
//       }));

//       setAssignedDevices(assigned);
//       setAvailableDevices(available);

//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to fetch sites");
//       setAssignedDevices([]);
//       setAvailableDevices([]);
//     } finally {
//       setLoading(false);
//     }
//   };


//   // Fetch sites on load
//   useEffect(() => {
//     const fetchCustomers = async () => {
//       try {
//         const res = await apiService({
//           url: `/api/get_customers/`,
//           method: "GET",
//           data: {},
//         });

//         const customersData = res.data || [];
//         setCustomers(customersData);

//         if (customersData.length > 0) {
//           const defaultId = customersData[0].tb_customer_id;
//           setSelectedCustomer(defaultId);
//           fetchSites(defaultId);
//         }
//       } catch (err) {
//         toast.error("Failed to fetch customers");
//       }
//     };

//     fetchCustomers();
//   }, []);


//   // const handleSiteChange = (e) => {
//   //   const siteId = e.target.value;
//   //   setSelectedSite(siteId);
//   //   fetchDevices(siteId);
//   // };

//   const handleAction = async (site, action) => {
//     try {
//       if (action === "assign") {
//         await axios.post(
//           `${API_URL}/api/assign_site_to_customer/`,
//           {
//             asset_id: site.id,
//             customer_id: selectedCustomer,
//           },
//           getConfig()
//         );

//         setAssignedDevices([...assignedDevices, { ...site, isAssigned: true }]);
//         setAvailableDevices(availableDevices.filter((s) => s.id !== site.id));

//         toast.success("Site assigned successfully");
//       } else {
//         await axios.delete(
//           `${API_URL}/api/unassign_site_to_customer/${site.id}/`,
//           getConfig()
//         );
//         setAvailableDevices([...availableDevices, { ...site, isAssigned: false }]);
//         setAssignedDevices(assignedDevices.filter((s) => s.id !== site.id));

//         toast.success("Site unassigned successfully");
//       }
//     } catch (err) {
//       console.log(err);
//       toast.error(err.response?.data?.error || "Action failed");
//     }
//   };

//   const getFilteredDevices = () => {
//     if (tabValue === 1) return assignedDevices;
//     if (tabValue === 2) return availableDevices;
//     return [...assignedDevices, ...availableDevices];
//   };

//   return (
//     <>
//       <Paper className="main-card-ui">
//         <Box className="header-row">
//           <TextField
//             select
//             label="Select Customer"
//             value={selectedCustomer}
//             onChange={(e) => {
//               const id = e.target.value;
//               setSelectedCustomer(id);
//               fetchSites(id);
//             }}
//             size="small"
//             className="device-select-input"
//           >
//             {customers.map((customer) => (
//               <MenuItem key={customer.tb_customer_id} value={customer.tb_customer_id}>
//                 {customer.customer_name}
//               </MenuItem>
//             ))}
//           </TextField>
//           <Box className="badge-container">
//             <div className="status-badge assigned">Assigned: {assignedDevices.length}</div>
//             <div className="status-badge available">Available: {availableDevices.length}</div>
//           </Box>
//         </Box>

//         <Box className="tabs-wrapper">
//           <Tabs
//             value={tabValue}
//             onChange={(e, v) => setTabValue(v)}
//             centered
//             className="custom-tabs"
//             TabIndicatorProps={{ style: { display: "none" } }}
//           >
//             <Tab label="All" />
//             <Tab label="Assigned" />
//             <Tab label="Available" />
//           </Tabs>
//         </Box>

//         <TableContainer className="table-container-ui orange-table">
//           {loading ? (
//             <Box textAlign="center" p={5}><CircularProgress /></Box>
//           ) : (
//             <Table stickyHeader sx={{ tableLayout: "fixed", width: "100%" }}>
//               <TableHead>
//                 <TableRow>
//                   <TableCell align="center">Site Name</TableCell>
//                   <TableCell align="center">Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {getFilteredDevices().length === 0 ? (
//                   <TableRow>
//                     <TableCell colSpan={2} align="center" style={{ padding: "20px", color: "#94a3b8" }}>
//                       No devices found.
//                     </TableCell>
//                   </TableRow>
//                 ) : (
//                   getFilteredDevices()
//                     .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                     .map((device) => (
//                       <TableRow key={device.id}>
//                         <TableCell align="center">{device.name}</TableCell>
//                         <TableCell align="center">
//                           {device.isAssigned ? (
//                             <Button className="btn-unmap" onClick={() => handleAction(device, "unassign")}>
//                               Unassign
//                             </Button>
//                           ) : (
//                             <Button className="btn-map" onClick={() => handleAction(device, "assign")}>
//                               Assign
//                             </Button>
//                           )}
//                         </TableCell>
//                       </TableRow>
//                     ))
//                 )}
//               </TableBody>
//             </Table>
//           )}


//           {/* After </TableContainer> */}
//           {!loading && getFilteredDevices().length > 0 && (
//             <div className="pagination-bar">
//               <div className="rows-select">
//                 Rows per page:
//                 <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
//                   <option value={5}>5</option>
//                   <option value={10}>10</option>
//                   <option value={25}>25</option>
//                 </select>
//               </div>
//               <div className="page-info">
//                 {page * rowsPerPage + 1}-
//                 {Math.min((page + 1) * rowsPerPage, getFilteredDevices().length)} of {getFilteredDevices().length}
//               </div>
//               <div className="page-arrows">
//                 <button disabled={page === 0} onClick={() => setPage(page - 1)}>‹</button>
//                 <button
//                   disabled={(page + 1) * rowsPerPage >= getFilteredDevices().length}
//                   onClick={() => setPage(page + 1)}
//                 >
//                   ›
//                 </button>
//               </div>
//             </div>
//           )}
//         </TableContainer>
//       </Paper>

//       <ToastContainer position="top-right" autoClose={2000} />
//     </>
//   );
// };

// export default MapSiteToCustomer;





















import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  TextField,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  CircularProgress,
  Tabs,
  Tab,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./MapDeviceToSite.css";
import apiService from "../../utils/apiservice";
import { useRef } from "react";



const API_URL = process.env.REACT_APP_API_DJANGO_URL;

const MapSiteToCustomer = () => {

  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [assignedDevices, setAssignedDevices] = useState([]);
  const [availableDevices, setAvailableDevices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);

  const token = localStorage.getItem("accessToken");
  const activeCustomerRef = useRef(null);



  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);


  useEffect(() => {
    setPage(0);
  }, [tabValue, selectedCustomer]);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getConfig = () => ({
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: {},
  });



  const fetchSites = async (customerId) => {
    try {
      setLoading(true);
      activeCustomerRef.current = customerId;

      setAssignedDevices([]);
      setAvailableDevices([]);


      const res = await apiService({
        url: `/api/get_sites_for_assignment/`,
        method: "GET",
        params: { customer_id: customerId },
      });

       if (activeCustomerRef.current !== customerId) return;


      // const assigned = (res.data.assigned_sites || []).map((d) => ({
      //   id: d.asset_id,
      //   name: d.name,
      //   isAssigned: true,
      // }));

      // const available = (res.data.unassigned_sites || []).map((d) => ({
      //   id: d.asset_id,
      //   name: d.name,
      //   isAssigned: false,
      // }));
      const assigned = (res.data.assigned_sites || [])
        .filter((d) => d.customer_id === customerId)
        .map((d) => ({
          id: d.asset_id,
          name: d.name,
          isAssigned: true,
        }));

      const available = (res.data.unassigned_sites || [])
        .filter((d) => d.customer_id === null || d.customer_id === customerId)
        .map((d) => ({
          id: d.asset_id,
          name: d.name,
          isAssigned: false,
        }));

      setAssignedDevices(assigned);
      setAvailableDevices(available);

    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch sites");
      setAssignedDevices([]);
      setAvailableDevices([]);
    } finally {
      setLoading(false);
    }
  };


  // Fetch sites on load
  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const res = await apiService({
          url: `/api/get_customers/`,
          method: "GET",
          data: {},
        });

        const customersData = res.data || [];
        setCustomers(customersData);

        if (customersData.length > 0) {
          const defaultId = customersData[0].tb_customer_id;
          setSelectedCustomer(defaultId);
          fetchSites(defaultId);
        }
      } catch (err) {
        toast.error("Failed to fetch customers");
      }
    };

    fetchCustomers();
  }, []);


  // const handleSiteChange = (e) => {
  //   const siteId = e.target.value;
  //   setSelectedSite(siteId);
  //   fetchDevices(siteId);
  // };

  const handleAction = async (site, action) => {
    try {
      if (action === "assign") {
        await axios.post(
          `${API_URL}/api/assign_site_to_customer/`,
          {
            asset_id: site.id,
            customer_id: selectedCustomer,
          },
          getConfig()
        );

        // setAssignedDevices([...assignedDevices, { ...site, isAssigned: true }]);
        // setAvailableDevices(availableDevices.filter((s) => s.id !== site.id));
        setAssignedDevices((prev) => [
          ...prev,
          { ...site, isAssigned: true }
        ]);

        setAvailableDevices((prev) =>
          prev.filter((s) => s.id !== site.id)
        );

        toast.success("Site assigned successfully");
      } else {
        await axios.delete(
          `${API_URL}/api/unassign_site_to_customer/${site.id}/`,
          getConfig()
        );
        // setAvailableDevices([...availableDevices, { ...site, isAssigned: false }]);
        // setAssignedDevices(assignedDevices.filter((s) => s.id !== site.id));
        setAvailableDevices((prev) => [
          ...prev,
          { ...site, isAssigned: false }
        ]);

        setAssignedDevices((prev) =>
          prev.filter((s) => s.id !== site.id)
        );

        toast.success("Site unassigned successfully");
      }
    } catch (err) {
      console.log(err);
      toast.error(err.response?.data?.error || "Action failed");
    }
  };

  const getFilteredDevices = () => {
    if (tabValue === 1) return assignedDevices;
    if (tabValue === 2) return availableDevices;
    return [...assignedDevices, ...availableDevices];
  };

  return (
    <>
      <Paper className="main-card-ui">
        <Box className="header-row">
          <TextField
            select
            label="Select Customer"
            value={selectedCustomer}
            // onChange={(e) => {
            //   const id = e.target.value;
            //   setSelectedCustomer(id);
            //   fetchSites(id);
            // }}
            onChange={(e) => {
              const id = e.target.value;
              setSelectedCustomer(id);

              setAssignedDevices([]);
              setAvailableDevices([]);
              setPage(0);

              fetchSites(id);
            }}
            size="small"
            className="device-select-input"
          >
            {customers.map((customer) => (
              <MenuItem key={customer.tb_customer_id} value={customer.tb_customer_id}>
                {customer.customer_name}
              </MenuItem>
            ))}
          </TextField>
          <Box className="badge-container">
            <div className="status-badge assigned">Assigned: {assignedDevices.length}</div>
            <div className="status-badge available">Available: {availableDevices.length}</div>
          </Box>
        </Box>

        <Box className="tabs-wrapper">
          <Tabs
            value={tabValue}
            onChange={(e, v) => setTabValue(v)}
            centered
            className="custom-tabs"
            TabIndicatorProps={{ style: { display: "none" } }}
          >
            <Tab label="All" />
            <Tab label="Assigned" />
            <Tab label="Available" />
          </Tabs>
        </Box>

        <TableContainer className="table-container-ui orange-table">
          {loading ? (
            <Box textAlign="center" p={5}><CircularProgress /></Box>
          ) : (
            <Table stickyHeader sx={{ tableLayout: "fixed", width: "100%" }}>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Site Name</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {getFilteredDevices().length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={2} align="center" style={{ padding: "20px", color: "#94a3b8" }}>
                      No devices found.
                    </TableCell>
                  </TableRow>
                ) : (
                  getFilteredDevices()
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((device) => (
                      <TableRow key={device.id}>
                        <TableCell align="center">{device.name}</TableCell>
                        <TableCell align="center">
                          {device.isAssigned ? (
                            <Button className="btn-unmap" onClick={() => handleAction(device, "unassign")}>
                              Unassign
                            </Button>
                          ) : (
                            <Button className="btn-map" onClick={() => handleAction(device, "assign")}>
                              Assign
                            </Button>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
          )}


          {/* After </TableContainer> */}
          {!loading && getFilteredDevices().length > 0 && (
            <div className="pagination-bar">
              <div className="rows-select">
                Rows per page:
                <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                </select>
              </div>
              <div className="page-info">
                {page * rowsPerPage + 1}-
                {Math.min((page + 1) * rowsPerPage, getFilteredDevices().length)} of {getFilteredDevices().length}
              </div>
              <div className="page-arrows">
                <button disabled={page === 0} onClick={() => setPage(page - 1)}>‹</button>
                <button
                  disabled={(page + 1) * rowsPerPage >= getFilteredDevices().length}
                  onClick={() => setPage(page + 1)}
                >
                  ›
                </button>
              </div>
            </div>
          )}
        </TableContainer>
      </Paper>

      <ToastContainer position="top-right" autoClose={2000} />
    </>
  );
};

export default MapSiteToCustomer;